import React from 'react';
import { Calendar, Clock, ArrowRight } from 'lucide-react';

const Blog = () => {
  const posts = [
    {
      title: "What is means to know something in the age of AI",
      excerpt: "The future we build will depend on people who dare to explore, to see, to understand, and to know. LLMs models can think, and they can guess, but they cannot know.",
      date: "2025-10-27",
      readTime: "5 min read",
      tags: ["LLMs", "Learning"]
    },
    {
      title: "Coming Soon",
      excerpt: "Coming Soon",
      date: "TBD",
      readTime: "TBD",
      tags: ["TBD"]
    },
    {
      title: "Coming Soon",
      excerpt: "Coming Soon",
      date: "TBD",
      readTime: "TBD",
      tags: ["TBD"]
    }
  ];

  const BlogPost = ({ post }) => (
    <article className="mondrian-card p-6 transition-all duration-300">
      <div className="flex items-center gap-4 text-gray-600 text-sm mb-4">
        <div className="flex items-center gap-1">
          <Calendar className="w-4 h-4" />
          <span>{new Date(post.date).toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}</span>
        </div>
        <div className="flex items-center gap-1">
          <Clock className="w-4 h-4" />
          <span>{post.readTime}</span>
        </div>
      </div>
      
      <h2 className="text-xl font-bold mb-3 text-black">
        {post.title}
      </h2>
      
      <p className="text-gray-700 mb-4 leading-relaxed">
        {post.excerpt}
      </p>
      
      <div className="flex flex-wrap gap-2 mb-6">
        {post.tags.map((tag, index) => {
          const colors = ['#E53935', '#1E88E5', '#FBC02D'];
          const bgColor = colors[index % colors.length];
          return (
            <span 
              key={tag} 
              className="px-3 py-1 text-xs font-bold border-2 border-black text-white"
              style={{ backgroundColor: bgColor }}
            >
              {tag}
            </span>
          );
        })}
      </div>
      
      <button className="flex items-center gap-2 text-[#E53935] hover:text-[#c62828] font-bold transition-colors group">
        Read More
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
      </button>
    </article>
  );

  return (
    <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-black">
            My Blog
          </h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Thoughts on building in the age of generative AI.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {posts.map((post, index) => (
            <BlogPost key={index} post={post} />
          ))}
        </div>

        <div className="text-center">
          <div className="mondrian-card p-8 relative overflow-hidden">
            <div className="absolute top-0 right-0 h-full accent-bar-red"></div>
            <h2 className="text-2xl font-bold text-black mb-4">Stay Updated</h2>
            <p className="text-gray-700 mb-6">
              I write about my coding adventures, project breakdowns, and lessons learned. 
              More posts coming soon!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <input
                type="email"
                placeholder="Enter your email"
                className="border-2 border-black px-4 py-2 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#E53935]"
              />
              <button className="bg-[#FBC02D] hover:bg-[#f9a825] px-6 py-2 border-2 border-black transition-all duration-200 text-black font-bold">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;